// IMPORTANT: Import CSP initialization FIRST before any other imports
// This ensures nonce is configured before Emotion or any other libraries load
import { getCspNonce } from './csp-init';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

import { AppThemeProvider } from '@datanomik/commons-ui';

import reportWebVitals from './reportWebVitals';

import Index from './views/base/Index';

import './styles/styles.scss';

// Create Emotion cache with nonce from CSP initialization
// CRITICAL: speedy must be false for CSP nonces to work
const emotionCache = createCache({
  key: 'css',
  nonce: getCspNonce(),
  prepend: false,
  speedy: false, // Required for nonce support
});

console.log('[Emotion] Cache initialized with speedy:', emotionCache.sheet.isSpeedy);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <HashRouter>
    <CacheProvider value={emotionCache}>
      <AppThemeProvider>
        <Index />
      </AppThemeProvider>
    </CacheProvider>
  </HashRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
